var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja"] = require( "front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja" );
dependencies["front/components/CommonVideoPlayer/CommonVideoPlayer.jinja"] = require( "front/components/CommonVideoPlayer/CommonVideoPlayer.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfile/MemberProfilePortfolioInner.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfile/MemberProfilePortfolioInner.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja", false, "assets/app/front/components/MemberProfile/MemberProfilePortfolioInner.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "MemberProfileButtonsEdit")) {
var t_7 = t_4.MemberProfileButtonsEdit;
} else {
cb(new Error("cannot import 'MemberProfileButtonsEdit'")); return;
}
context.setVariable("MemberProfileButtonsEdit", t_7);
output += "\n";
env.getTemplate("front/components/CommonVideoPlayer/CommonVideoPlayer.jinja", false, "assets/app/front/components/MemberProfile/MemberProfilePortfolioInner.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "CommonVideoPlayer")) {
var t_11 = t_8.CommonVideoPlayer;
} else {
cb(new Error("cannot import 'CommonVideoPlayer'")); return;
}
context.setVariable("CommonVideoPlayer", t_11);
output += "\n\n";
var macro_t_12 = runtime.makeMacro(
[], 
["data", "isOwner"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("isOwner", Object.prototype.hasOwnProperty.call(kwargs, "isOwner") ? kwargs["isOwner"] : false);var t_13 = "";t_13 += "\n    <div class=\"MemberProfilePortfolioInner";
if(runtime.contextOrFrameLookup(context, frame, "isOwner") && (!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolioPublic"))) {
t_13 += " hidden";
;
}
t_13 += "\">\n        <div class=\"MemberProfilePortfolioInner-title\">\n            Selected Portfolio\n        </div>\n        <div class=\"MemberProfilePortfolioInner-content";
if(!(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio")))) {
t_13 += " isEmpty";
;
}
t_13 += "\">\n\n            ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio")))) {
t_13 += "\n\n\n                <div class=\"MemberProfilePortfolioInner-mainGalleryWrapper\" data-state=\"normal\">\n\n                    <div class=\"MemberProfilePortfolioInner-mainGalleryWrapperClose\">\n                        ";
t_13 += runtime.suppressValue((lineno = 18, colno = 46, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["popup-close-fullscreen","0 0 21 21",runtime.makeKeywordArgs({"caller": (function (){var macro_t_14 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_15 = "";;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
return macro_t_14;})()})])), env.opts.autoescape);
t_13 += "\n                    </div>\n\n                    <div class=\"MemberProfilePortfolioInner-mainGallery\">\n                        <div class=\"MemberProfilePortfolioInner-mainGalleryCarousel owl-carousel owl-theme\">\n                            ";
frame = frame.push();
var t_18 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio");
if(t_18) {t_18 = runtime.fromIterator(t_18);
var t_17 = t_18.length;
for(var t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16];
frame.set("item", t_19);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
t_13 += "\n                                <div class=\"MemberProfilePortfolioInner-mainGalleryCarouselItem\" data-component=\"";
t_13 += runtime.suppressValue(runtime.memberLookup((t_19),"component"), env.opts.autoescape);
t_13 += "\">\n                                    ";
if(runtime.memberLookup((t_19),"component") == "image") {
t_13 += "\n                                        <img src=\"";
t_13 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_19),"cover")),"w920_url"), env.opts.autoescape);
t_13 += "\"\n                                          srcset=\"";
if((runtime.memberLookup((runtime.memberLookup((t_19),"cover")),"w1680_url"))) {
t_13 += " ";
t_13 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_19),"cover")),"w1680_url"), env.opts.autoescape);
t_13 += " 1680w,";
;
}
t_13 += "\n                                                  ";
t_13 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_19),"cover")),"w920_url"), env.opts.autoescape);
t_13 += " 920w,\n                                                  ";
t_13 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_19),"cover")),"w680_url"), env.opts.autoescape);
t_13 += " 680w\"\n                                          sizes=\"(max-width: 759px) 1, ";
t_13 += "\n                                                 100vw\"\n                                          alt=\"\">\n                                    ";
;
}
else {
t_13 += "\n                                        ";
t_13 += runtime.suppressValue((lineno = 34, colno = 58, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonVideoPlayer"), "CommonVideoPlayer", context, [runtime.makeKeywordArgs({"data": {"provider": runtime.memberLookup((t_19),"videoProvider"),"cover": runtime.memberLookup((t_19),"cover"),"code": runtime.memberLookup((t_19),"videoCode")},"delayed": 1})])), env.opts.autoescape);
t_13 += "\n                                    ";
;
}
t_13 += "\n\n                                    ";
if(runtime.memberLookup((t_19),"caption") && runtime.memberLookup((t_19),"component") == "image") {
t_13 += "\n                                        <div class=\"MemberProfilePortfolioInner-mainGalleryCarouselItemCaption\">\n                                            ";
t_13 += runtime.suppressValue(runtime.memberLookup((t_19),"caption"), env.opts.autoescape);
t_13 += "\n                                        </div>\n                                    ";
;
}
t_13 += "\n\n                                </div>\n                            ";
;
}
}
frame = frame.pop();
t_13 += "\n                        </div>\n\n                        <div class=\"MemberProfilePortfolioInner-mainGalleryCaptionWrapper\">\n                            <div class=\"MemberProfilePortfolioInner-mainGalleryCaption\"></div>\n                        </div>\n\n                        <div class=\"MemberProfilePortfolioInner-mainGalleryPrev\">\n                            ";
t_13 += runtime.suppressValue((lineno = 52, colno = 50, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["fullscreen-prev","0 0 50 42",runtime.makeKeywordArgs({"caller": (function (){var macro_t_20 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_21 = "";;
frame = frame.pop();
return new runtime.SafeString(t_21);
});
return macro_t_20;})()})])), env.opts.autoescape);
t_13 += "\n                            ";
t_13 += runtime.suppressValue((lineno = 53, colno = 50, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["gallery-arrow-prev","0 0 30 26",runtime.makeKeywordArgs({"caller": (function (){var macro_t_22 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_23 = "";;
frame = frame.pop();
return new runtime.SafeString(t_23);
});
return macro_t_22;})()})])), env.opts.autoescape);
t_13 += "\n                        </div>\n\n                        <div class=\"MemberProfilePortfolioInner-mainGalleryNext\">\n                            ";
t_13 += runtime.suppressValue((lineno = 57, colno = 50, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["fullscreen-next","0 0 50 42",runtime.makeKeywordArgs({"caller": (function (){var macro_t_24 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_25 = "";;
frame = frame.pop();
return new runtime.SafeString(t_25);
});
return macro_t_24;})()})])), env.opts.autoescape);
t_13 += "\n                            ";
t_13 += runtime.suppressValue((lineno = 58, colno = 50, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["gallery-arrow-next","0 0 30 26",runtime.makeKeywordArgs({"caller": (function (){var macro_t_26 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_27 = "";;
frame = frame.pop();
return new runtime.SafeString(t_27);
});
return macro_t_26;})()})])), env.opts.autoescape);
t_13 += "\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"MemberProfilePortfolioInner-thumbsGallery\">\n                    <div class=\"MemberProfilePortfolioInner-thumbsGalleryCarousel owl-carousel owl-theme\">\n                        ";
frame = frame.push();
var t_30 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio");
if(t_30) {t_30 = runtime.fromIterator(t_30);
var t_29 = t_30.length;
for(var t_28=0; t_28 < t_30.length; t_28++) {
var t_31 = t_30[t_28];
frame.set("item", t_31);
frame.set("loop.index", t_28 + 1);
frame.set("loop.index0", t_28);
frame.set("loop.revindex", t_29 - t_28);
frame.set("loop.revindex0", t_29 - t_28 - 1);
frame.set("loop.first", t_28 === 0);
frame.set("loop.last", t_28 === t_29 - 1);
frame.set("loop.length", t_29);
t_13 += "\n                            <div class=\"MemberProfilePortfolioInner-thumbsGalleryCarouselItem";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0) {
t_13 += " play";
;
}
t_13 += "\"\n                                 data-id=\"";
t_13 += runtime.suppressValue(runtime.memberLookup((t_31),"id"), env.opts.autoescape);
t_13 += "\" data-ind=\"";
t_13 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
t_13 += "\">\n                                <figure>\n                                    <div class=\"MemberProfilePortfolioInner-thumbsGalleryCarouselItemPreview\">\n                                        <div class=\"MemberProfilePortfolioInner-thumbsGalleryCarouselItemPreviewWrapper\">\n                                            <img src=\"";
t_13 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_31),"cover")),"w680_url"), env.opts.autoescape);
t_13 += "\" alt=\"\">\n                                        </div>\n                                        ";
if(runtime.memberLookup((t_31),"component") == "video") {
t_13 += "\n                                            <div class=\"MemberProfilePortfolioInner-thumbsGalleryCarouselItemBtnPlayWrapper\">\n                                                <div class=\"MemberProfilePortfolioInner-thumbsGalleryCarouselItemBtnPlay\"></div>\n                                            </div>\n                                        ";
;
}
t_13 += "\n                                    </div>\n                                </figure>\n                            </div>\n                        ";
;
}
}
frame = frame.pop();
t_13 += "\n                    </div>\n                </div>\n\n            ";
;
}
else {
t_13 += "\n                <div class=\"MemberProfilePortfolioInner-content-textEmpty\">\n                    <p>You can quickly and easily create a gallery slideshow to showcase some of your work by uploading\n                        multiple images and videos.</p>\n                    <div class=\"MemberProfilePortfolioInner-content-createPortfolio\">\n                        <div class=\"MemberProfilePortfolioInner-content-createPortfolio-btn\">\n                            Create slideshow\n                        </div>\n                    </div>\n                </div>\n            ";
;
}
t_13 += "\n\n        </div>\n    </div>\n\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "isOwner")) {
t_13 += "\n        <div class=\"MemberProfileCredits-buttonsEdit\">\n            ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolio")))) {
t_13 += "\n                ";
t_13 += runtime.suppressValue((lineno = 104, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileButtonsEdit"), "MemberProfileButtonsEdit", context, [runtime.makeKeywordArgs({"block": "portfolio","isVisible": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"portfolioPublic"),"memberId": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id")})])), env.opts.autoescape);
t_13 += "\n            ";
;
}
else {
t_13 += "\n                ";
t_13 += runtime.suppressValue((lineno = 106, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileButtonsEdit"), "MemberProfileButtonsEdit", context, [runtime.makeKeywordArgs({"hidden": false,"block": "portfolio","memberId": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id")})])), env.opts.autoescape);
t_13 += "\n            ";
;
}
t_13 += "\n        </div>\n    ";
;
}
t_13 += "\n";
;
frame = callerFrame;
return new runtime.SafeString(t_13);
});
context.addExport("MemberProfilePortfolioInner");
context.setVariable("MemberProfilePortfolioInner", macro_t_12);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfile/MemberProfilePortfolioInner.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfilePortfolioInner.jinja
// module id = 49
// module chunks = 0